<app-progress-bar></app-progress-bar>
<main>
  @if( this._userService.typeUser === 1 ) {
  <main class="background-image-container">
    <section class="register-section">
      <img
        class="login-section__logo"
        [src]="this._userService.storeConfig?.storeLogo"
        alt="Submmit Materialss Logo"
        width="130.51"
      />
      <h2 class="register-section__title">{{ "mcfLoginShell.signup.title" | translate }}</h2>

      <form class="register-section__form" [formGroup]="myForm">
        <div class="inputs-container">
          <article class="form-field">
            <label class="input--required">{{
              "mcfLoginShell.signup.firstName" | translate
            }}</label>
            <input
              pInputText
              formControlName="firstName"
              type="text"
              placeholder="{{ 'mcfLoginShell.signup.firstNamePlaceholder' | translate }}"
              [ngClass]="{ 'input-error': myForm.get('firstName')?.invalid && (myForm.get('firstName')?.touched || myForm.get('firstName')?.dirty) }"
            />
            <ng-container
              *ngIf="
                myForm.get('firstName')?.errors &&
                (myForm.get('firstName')?.touched ||
                  myForm.get('firstName')?.dirty)
              "
            >              <small
                class="p-error"
                *ngIf="myForm.get('firstName')?.errors?.['required']"
                >{{ "transversales.formLabels.layoutNameRequired" | translate }}</small
              >
              <small
                class="p-error"
                *ngIf="myForm.get('firstName')?.errors?.['minlength']"
                >{{ "transversales.formLabels.nameMin2Chars" | translate }}</small
              >
              <small
                class="p-error"
                *ngIf="myForm.get('firstName')?.errors?.['maxlength']"
                >{{ "transversales.formLabels.nameMax50Chars" | translate }}</small
              >
              <small
                class="p-error"
                *ngIf="myForm.get('firstName')?.errors?.['pattern']"
                >{{ "transversales.formLabels.nameInvalidChars" | translate }}</small
              >
            </ng-container>
          </article>

          <article class="form-field">
            <label class="input--required">{{
              "mcfLoginShell.signup.lastName" | translate
            }}</label>
            <input
              pInputText
              formControlName="lastName"
              type="text"
              placeholder="{{ 'mcfLoginShell.signup.lastNamePlaceholder' | translate }}"
              [ngClass]="{ 'input-error': myForm.get('lastName')?.invalid && (myForm.get('lastName')?.touched || myForm.get('lastName')?.dirty) }"
            />
            <ng-container
              *ngIf="
                myForm.get('lastName')?.errors &&
                (myForm.get('lastName')?.touched ||
                  myForm.get('lastName')?.dirty)
              "
            >
              <small
                class="p-error"
                *ngIf="myForm.get('lastName')?.errors?.['required']"
                >{{ "transversales.formLabels.lastNameRequired" | translate }}</small
              >
              <small
                class="p-error"
                *ngIf="myForm.get('lastName')?.errors?.['minlength']"
                >{{ "transversales.formLabels.lastNameMin2Chars" | translate }}</small
              >
              <small
                class="p-error"
                *ngIf="myForm.get('lastName')?.errors?.['maxlength']"
                >{{ "transversales.formLabels.lastNameMax50Chars" | translate }}</small
              >
              <small
                class="p-error"
                *ngIf="myForm.get('lastName')?.errors?.['pattern']"
                >{{ "transversales.formLabels.lastNameInvalidChars" | translate }}</small
              >
            </ng-container>
          </article>

          <article class="form-field">
            <label class="input--required">{{
              "mcfLoginShell.signup.documentNumberId" | translate
            }}</label>
            <input
              pInputText
              formControlName="documentNumberId"
              type="text"
              maxlength="50"
              placeholder="{{ 'mcfLoginShell.signup.documentNumberIdPlaceHolder' | translate }}"
              [ngClass]="{ 'input-error': myForm.get('documentNumberId')?.invalid && (myForm.get('documentNumberId')?.touched || myForm.get('documentNumberId')?.dirty) }"
            />
            <ng-container
              *ngIf="
                myForm.get('documentNumberId')?.errors &&
                (myForm.get('documentNumberId')?.touched ||
                  myForm.get('documentNumberId')?.dirty)
              "
            >
              <small
                class="p-error"
                *ngIf="myForm.get('documentNumberId')?.errors?.['required']"
                >{{ "transversales.formLabels.documentNumberIdRequired" | translate }}</small
              >
              <small
                class="p-error"
                *ngIf="myForm.get('documentNumberId')?.errors?.['maxlength']"
                >{{ "transversales.formLabels.documentNumberIdMax50Chars" | translate }}</small
              >
            </ng-container>
          </article>

          <article class="form-field">
            <label class="input--required">{{
              "mcfLoginShell.signup.emailAddress" | translate
            }}</label>
            <input
              pInputText
              formControlName="emailAddress"
              type="email"
              placeholder="{{ 'mcfLoginShell.signup.emailPlaceholder' | translate }}"
              [ngClass]="{ 'input-error': myForm.get('emailAddress')?.invalid && (myForm.get('emailAddress')?.touched || myForm.get('emailAddress')?.dirty) }"
            />
            <ng-container
              *ngIf="
                myForm.get('emailAddress')?.errors &&
                (myForm.get('emailAddress')?.touched ||
                  myForm.get('emailAddress')?.dirty)
              "
            >
              <small
                class="p-error"
                *ngIf="myForm.get('emailAddress')?.errors?.['required']"
                >{{ "transversales.formLabels.emailRequired" | translate }}</small
              >
              <small
                class="p-error"
                *ngIf="myForm.get('emailAddress')?.errors?.['email']"
                >{{ "transversales.formLabels.emailInvalid" | translate }}</small
              >
              <small
                class="p-error"
                *ngIf="myForm.get('emailAddress')?.errors?.['existingEmail']"
                >{{ "transversales.formLabels.existingEmail" | translate }}</small
              >
            </ng-container>
          </article>
          <article class="form-field">
            <label class="input--required">{{
              "mcfLoginShell.signup.phoneNumber" | translate
            }}</label>
            <p-inputNumber
              [useGrouping]="false"
              [style]="{ width: '100%', height: '39px' }"
              [styleClass]="myForm.get('phoneNumber')?.invalid && (myForm.get('phoneNumber')?.touched || myForm.get('phoneNumber')?.dirty) ? 'input-error' : ''"
              mode="decimal"
              [prefix]="this._userService.storeConfig?.callingCode + '  '"
              formControlName="phoneNumber"
              type="number"
              placeholder="{{ 'mcfLoginShell.signup.phoneNumberPlaceholder' | translate }}"
            />


             <ng-container
      *ngIf="
        myForm.get('phoneNumber')?.errors &&
        (myForm.get('phoneNumber')?.touched ||
          myForm.get('phoneNumber')?.dirty)
      ">
        <small class="p-error" *ngIf="myForm.get('phoneNumber')?.errors?.['required']">{{
          "transversales.formLabels.phoneNumberRequired" | translate }}</small>

               <small class="p-error" *ngIf="myForm.get('phoneNumber')?.errors?.['pattern']">{{ "transversales.formLabels.invalidPhoneFormat"
          | translate }}</small>
      </ng-container>
          </article>
          <article class="form-field">
            <label>{{ "mcfLoginShell.signup.birthday" | translate }}</label>
            <p-calendar
              formControlName="birthday"
              [dateFormat]="this._userService.storeConfig?.dateFormat"
              placeholder="{{ 'mcfLoginShell.signup.datePlaceholder' | translate }}"
              [iconDisplay]="'input'"
              [showIcon]="true"
              inputId="buttondisplay"
              [style]="{ width: '100%' }"
              [inputStyle]="{ width: '100%', fontSize: '13px' }"
              [readonlyInput]="true"
            />
            <ng-container
              *ngIf="
                myForm.get('birthday')?.errors &&
                (myForm.get('birthday')?.touched ||
                  myForm.get('birthday')?.dirty)
              "
            >
              <small
                class="p-error"
                *ngIf="myForm.get('birthday')?.errors?.['invalidDate']"
                >{{ "transversales.formLabels.invalidDateFormat" | translate }}</small
              >
            </ng-container>
          </article>
          <article class="form-field">
            <label class="input--required">{{
              "mcfLoginShell.signup.fiscalId" | translate
            }}</label>
            <input
              pInputText
              formControlName="fiscalId"
              placeholder="{{ 'mcfLoginShell.signup.fiscalIdPlaceholder' | translate }}"
              [ngClass]="{ 'input-error': myForm.get('fiscalId')?.invalid && (myForm.get('fiscalId')?.touched || myForm.get('fiscalId')?.dirty) }"
            />
            <ng-container
              *ngIf="
                myForm.get('fiscalId')?.errors &&
                (myForm.get('fiscalId')?.touched ||
                  myForm.get('fiscalId')?.dirty)
              "
            >
              <small
                class="p-error"
                *ngIf="myForm.get('fiscalId')?.errors?.['required']"
                >{{ "transversales.formLabels.fiscalIdRequired" | translate }}</small
              >
              <small
                class="p-error"
                *ngIf="myForm.get('fiscalId')?.errors?.['existingFiscalId']"
                >{{ "transversales.formLabels.existingFiscalId" | translate }}</small
              >
              <small
                class="p-error"
                *ngIf="myForm.get('fiscalId')?.errors?.['invalidFormat']"
                >{{ "transversales.formLabels.invalidFiscalIdFormat" | translate }}</small
              >
              <small
              class="p-error"
              *ngIf="myForm.get('fiscalId')?.errors?.['pattern']"
              >{{ "transversales.formLabels.invalidFiscalIdFormat" | translate }}</small
            >
            </ng-container>
          </article>

          <article class="form-field">
            <label>{{ "mcfLoginShell.signup.jobTitle" | translate }}</label>
            <input
              pInputText
              formControlName="jobTitle"
              placeholder="{{ 'mcfLoginShell.signup.jobTitlePlaceholder' | translate }}"
            />
            <span class="inputs-container__small-text">{{
              "mcfLoginShell.signup.jobTitleHint" | translate
            }}</span>
            <ng-container
              *ngIf="
                myForm.get('jobTitle')?.errors &&
                (myForm.get('jobTitle')?.touched ||
                  myForm.get('jobTitle')?.dirty)
              "
            >
              <small
                class="p-error"
                *ngIf="myForm.get('jobTitle')?.errors?.['maxlength']"
                >{{ "transversales.formLabels.jobTitleMax100Chars" | translate }}</small
              >
              @if(myForm.get('jobTitle')?.errors?.['pattern']){
                <small class="p-error">{{"transversales.formLabels.jobTitleInvalidPattern"|translate}}</small>
                }
            </ng-container>
          </article>

          <article class="form-field" *ngIf="stateFieldVisible">
            <label [ngClass]="{ 'input--required': stateFieldRequired }">{{ "mcfLoginShell.signup.state" | translate }}</label>
            <p-dropdown
              [options]="states"
              formControlName="stateCountryId"
              optionLabel="name"
              optionValue="stateCountryId"
              [showClear]="true"
              [filter]="true"
              [style]="{ width: '100%' }"
              [styleClass]="myForm.get('stateCountryId')?.invalid && (myForm.get('stateCountryId')?.touched || myForm.get('stateCountryId')?.dirty) ? 'input-error' : ''"
              placeholder="{{ 'transversales.dropDownSelect' | translate }}"
              (onChange)="onStateChange($event.value)"
              (onClear)="onStateChange(null)"
            />
            <ng-container
              *ngIf="
                myForm.get('stateCountryId')?.errors &&
                (myForm.get('stateCountryId')?.touched ||
                  myForm.get('stateCountryId')?.dirty)
              "
            >
              <small
                class="p-error"
                *ngIf="myForm.get('stateCountryId')?.errors?.['required']"
                >{{ "transversales.formLabels.stateCountryIdRequired" | translate }}</small
              >
            </ng-container>
          </article>

          <article class="form-field" *ngIf="cityFieldVisible">
            <label [ngClass]="{ 'input--required': cityFieldRequired }">{{ "mcfLoginShell.signup.city" | translate }}</label>
            <p-dropdown
              [options]="filteredCities"
              formControlName="cityId"
              optionLabel="name"
              optionValue="cityId"
              [showClear]="true"
              [filter]="true"
              [style]="{ width: '100%' }"
              [styleClass]="myForm.get('cityId')?.invalid && (myForm.get('cityId')?.touched || myForm.get('cityId')?.dirty) ? 'input-error' : ''"
              placeholder="{{ 'transversales.dropDownSelect' | translate }}"
            />
            <ng-container
              *ngIf="
                myForm.get('cityId')?.errors &&
                (myForm.get('cityId')?.touched ||
                  myForm.get('cityId')?.dirty)
              "
            >
              <small
                class="p-error"
                *ngIf="myForm.get('cityId')?.errors?.['required']"
                >{{ "transversales.formLabels.cityIdRequired" | translate }}</small
              >
            </ng-container>
          </article>
        </div>
        <div class="check-options" [ngClass]="{ 'mt-29': stateFieldVisible || cityFieldVisible }">
          <h2 class="register-section__title">
            {{ "mcfLoginShell.signup.featuresTitle" | translate }}
          </h2>
          @if(generalPermissions.length > 0) {
            <p class="check-options__type-label">{{ 'mcfLoginShell.signup.generalSection' | translate }}</p>
            <section class="register-section__permissions">
              <article class="check-options__item" *ngFor="let permission of generalPermissions">
                <p-checkbox
                  disabled="{{ permission.isRequired }}"
                  inputId="{{ permission.id }}"
                  (onChange)="togglePermission(permission)"
                  [binary]="true"
                  [ngModel]="permission.isRequired"
                  [ngModelOptions]="{ standalone: true }"
                />
                <label class="check-options__label" [for]="permission.id">{{ permission.description | translate }}</label>
              </article>
            </section>
          }
          @if(cementoPermissions.length > 0) {
            <p class="check-options__type-label">{{ 'mcfLoginShell.signup.cementoSection' | translate }}</p>
            <section class="register-section__permissions">
              <article class="check-options__item" *ngFor="let permission of cementoPermissions">
                <p-checkbox
                  disabled="{{ permission.isRequired }}"
                  inputId="{{ permission.id }}"
                  (onChange)="togglePermission(permission)"
                  [binary]="true"
                  [ngModel]="permission.isRequired"
                  [ngModelOptions]="{ standalone: true }"
                />
                <label class="check-options__label" [for]="permission.id">{{ permission.description | translate }}</label>
              </article>
            </section>
          }
          @if(concretoPermissions.length > 0) {
            <p class="check-options__type-label">{{ 'mcfLoginShell.signup.concretoSection' | translate }}</p>
            <section class="register-section__permissions">
              <article class="check-options__item" *ngFor="let permission of concretoPermissions">
                <p-checkbox
                  disabled="{{ permission.isRequired }}"
                  inputId="{{ permission.id }}"
                  (onChange)="togglePermission(permission)"
                  [binary]="true"
                  [ngModel]="permission.isRequired"
                  [ngModelOptions]="{ standalone: true }"
                />
                <label class="check-options__label" [for]="permission.id">{{ permission.description | translate }}</label>
              </article>
            </section>
          }
          <div class="divider"></div>
          <article class="check-options__item terms-container">            <p-checkbox
              formControlName="termsAndConditions"
              inputId="option-five"
              [binary]="true"
            />
            <label class="check-options__label"
              >{{ 'mcfLoginShell.signup.iAccept' | translate }}
              <a href="#" (click)="openTerms($event)"
                >{{ 'mcfLoginShell.signup.termsConditionsPrivacy' | translate }}</a
              >
            </label>
          </article>
        </div>



          <div class="register-section__buttons-container">
            <button
              class="register-section__button"
              (click)="goBack()"
              type="button"
            >
            <i class="icon-arrow-back"></i>
              {{ "mcfLoginShell.signup.back" | translate }}
            </button>
            <p-button
              class="register-section__button--prime-button button--active"
              [disabled]="!myForm.get('termsAndConditions')?.value || loading"
              (click)="submitForm()"
              type="submit"
            >
            <i class="icon-approved"></i>
              {{ "mcfLoginShell.signup.send" | translate }}
              </p-button
            >
          </div>
        </form>
      </section>
    </main>
  }
  @else {
    <main class="background-image-container">
        <section class="register-section">
          <img class="login-section__logo"  [src]="this._userService.storeConfig?.storeLogo" alt="Store Logo" width="130.51">
          <h2 class="register-section__title">{{ 'mcfLoginShell.signup.completeInfo' | translate }}</h2>
          <form class="register-section__form"  [formGroup]="myForm">
            <div class="inputs-container-federation">
              <article class="form-field">
                <label>{{ "mcfLoginShell.signup.birthday" | translate }}</label>
                <p-calendar
                  formControlName="birthday"
                  [dateFormat]="this._userService.storeConfig?.dateFormat"
                  placeholder="{{ 'mcfLoginShell.signup.datePlaceholder' | translate }}"
                  [iconDisplay]="'input'"
                  [showIcon]="true"
                  inputId="buttondisplay"
                  [style]="{ width: '100%' }"
                  [inputStyle]="{ width: '100%', fontSize: '13px' }"
                />
                <ng-container
                  *ngIf="
                    myForm.get('birthday')?.errors &&
                    (myForm.get('birthday')?.touched ||
                      myForm.get('birthday')?.dirty)
                  "
                >
                  <small
                    class="p-error"
                    *ngIf="myForm.get('birthday')?.errors?.['invalidDate']"
                    >{{ "transversales.formLabels.invalidDateFormat" | translate }}</small
                  >
                </ng-container>
              </article>
              <article class="form-field">
                <label class="input--required">{{
                  "mcfLoginShell.signup.phoneNumber" | translate
                }}</label>
                <p-inputNumber
                  [useGrouping]="false"
                  [style]="{ width: '100%', height: '39px' }"
                  [styleClass]="myForm.get('phoneNumber')?.invalid && (myForm.get('phoneNumber')?.touched || myForm.get('phoneNumber')?.dirty) ? 'input-error' : ''"
                  mode="decimal"
                  [prefix]="this._userService.storeConfig?.callingCode + '  '"
                  formControlName="phoneNumber"
                  type="number"
                  placeholder="{{ 'mcfLoginShell.signup.phoneNumberPlaceholder' | translate }}"
                />
                <ng-container
                  *ngIf="
                    myForm.get('phoneNumber')?.errors &&
                    (myForm.get('phoneNumber')?.touched ||
                      myForm.get('phoneNumber')?.dirty)
                  "
                >
                  <small
                    class="p-error"
                    *ngIf="myForm.get('phoneNumber')?.errors?.['required']"
                    >{{ "transversales.formLabels.phoneNumberRequired" | translate }}</small
                  >

               <small class="p-error" *ngIf="myForm.get('phoneNumber')?.errors?.['pattern']">{{ "transversales.formLabels.invalidPhoneFormat"
          | translate }}</small>
                </ng-container>
              </article>
              <article class="form-field">
                <label class="input--required">{{
                  "mcfLoginShell.signup.fiscalId" | translate
                }}</label>
                <input
                  pInputText
                  formControlName="fiscalId"
                  placeholder="{{ 'mcfLoginShell.signup.fiscalIdPlaceholder' | translate }}"
                />
                <ng-container
                  *ngIf="
                    myForm.get('fiscalId')?.errors &&
                    (myForm.get('fiscalId')?.touched ||
                      myForm.get('fiscalId')?.dirty)
                  "
                >
                  <small
                    class="p-error"
                    *ngIf="myForm.get('fiscalId')?.errors?.['required']"
                    >{{ "transversales.formLabels.fiscalIdRequired" | translate }}</small
                  >
                  <small
                    class="p-error"
                    *ngIf="myForm.get('fiscalId')?.errors?.['existingFiscalId']"
                    >{{ "transversales.formLabels.existingFiscalId" | translate }}</small
                  >
                  <small
                    class="p-error"
                    *ngIf="myForm.get('fiscalId')?.errors?.['invalidFormat']"
                    >{{ "transversales.formLabels.invalidFiscalIdFormat" | translate }}</small
                  >
                  <small
                  class="p-error"
                  *ngIf="myForm.get('fiscalId')?.errors?.['pattern']"
                  >{{ "transversales.formLabels.invalidFiscalIdFormat" | translate }}</small
                >
                </ng-container>
              </article>
              <article class="full-input form-field">
                <label>{{ "mcfLoginShell.signup.jobTitle" | translate }}</label>
                <input
                  pInputText
                  formControlName="jobTitle"
                  placeholder="{{ 'mcfLoginShell.signup.jobTitlePlaceholder' | translate }}"
                />
                <span class="inputs-container__small-text">{{
                  "mcfLoginShell.signup.jobTitleHint" | translate
                }}</span>
                <ng-container
                  *ngIf="
                    myForm.get('jobTitle')?.errors &&
                    (myForm.get('jobTitle')?.touched ||
                      myForm.get('jobTitle')?.dirty)
                  "
                >
                  <small
                    class="p-error"
                    *ngIf="myForm.get('jobTitle')?.errors?.['maxlength']"
                    >{{ "transversales.formLabels.jobTitleMax100Chars" | translate }}</small
                  >
                  @if(myForm.get('jobTitle')?.errors?.['pattern']){
                    <small class="p-error">{{"transversales.formLabels.jobTitleInvalidPattern"|translate}}</small>
                    }
                </ng-container>
              </article>

              <article class="form-field" *ngIf="stateFieldVisible">
                <label [ngClass]="{ 'input--required': stateFieldRequired }">{{ "mcfLoginShell.signup.state" | translate }}</label>
                <p-dropdown
                  [options]="states"
                  formControlName="stateCountryId"
                  optionLabel="name"
                  optionValue="stateCountryId"
                  [showClear]="true"
                  [filter]="true"
                  [style]="{ width: '90%' }"
                  [styleClass]="myForm.get('stateCountryId')?.invalid && (myForm.get('stateCountryId')?.touched || myForm.get('stateCountryId')?.dirty) ? 'input-error' : ''"
                  placeholder="{{ 'mcfLoginShell.signup.statePlaceholder' | translate }}"
                  (onChange)="onStateChange($event.value)"
                  (onClear)="onStateChange(null)"
                />
                <ng-container
                  *ngIf="
                    myForm.get('stateCountryId')?.errors &&
                    (myForm.get('stateCountryId')?.touched ||
                      myForm.get('stateCountryId')?.dirty)
                  "
                >
                  <small
                    class="p-error"
                    *ngIf="myForm.get('stateCountryId')?.errors?.['required']"
                    >{{ "transversales.formLabels.stateCountryIdRequired" | translate }}</small
                  >
                </ng-container>
              </article>

              <article class="form-field" *ngIf="cityFieldVisible">
                <label [ngClass]="{ 'input--required': cityFieldRequired }">{{ "mcfLoginShell.signup.city" | translate }}</label>
                <p-dropdown
                  [options]="filteredCities"
                  formControlName="cityId"
                  optionLabel="name"
                  optionValue="cityId"
                  [showClear]="true"
                  [filter]="true"
                  [style]="{ width: '100%' }"
                  [styleClass]="myForm.get('cityId')?.invalid && (myForm.get('cityId')?.touched || myForm.get('cityId')?.dirty) ? 'input-error' : ''"
                  placeholder="{{ 'mcfLoginShell.signup.cityPlaceholder' | translate }}"
                />
                <ng-container
                  *ngIf="
                    myForm.get('cityId')?.errors &&
                    (myForm.get('cityId')?.touched ||
                      myForm.get('cityId')?.dirty)
                  "
                >
                  <small
                    class="p-error"
                    *ngIf="myForm.get('cityId')?.errors?.['required']"
                    >{{ "transversales.formLabels.cityIdRequired" | translate }}</small
                  >
                </ng-container>
              </article>
            </div>
            <div class="check-options">
              <h2 class="register-section__title">
                {{ "mcfLoginShell.signup.featuresTitle" | translate }}
              </h2>
              @if(generalPermissions.length > 0) {
                <p class="check-options__type-label">{{ 'mcfLoginShell.signup.generalSection' | translate }}</p>
                <article class="check-options__item" *ngFor="let permission of generalPermissions">
                  <p-checkbox
                    disabled="{{ permission.isRequired }}"
                    inputId="{{ permission.id }}"
                    (onChange)="togglePermission(permission)"
                    [binary]="true"
                    [ngModel]="permission.isRequired"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <label class="check-options__label" [for]="permission.id">{{ permission.description | translate }}</label>
                </article>
              }
              @if(cementoPermissions.length > 0) {
                <p class="check-options__type-label">{{ 'mcfLoginShell.signup.cementoSection' | translate }}</p>
                <article class="check-options__item" *ngFor="let permission of cementoPermissions">
                  <p-checkbox
                    disabled="{{ permission.isRequired }}"
                    inputId="{{ permission.id }}"
                    (onChange)="togglePermission(permission)"
                    [binary]="true"
                    [ngModel]="permission.isRequired"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <label class="check-options__label" [for]="permission.id">{{ permission.description | translate }}</label>
                </article>
              }
              @if(concretoPermissions.length > 0) {
                <p class="check-options__type-label">{{ 'mcfLoginShell.signup.concretoSection' | translate }}</p>
                <article class="check-options__item" *ngFor="let permission of concretoPermissions">
                  <p-checkbox
                    disabled="{{ permission.isRequired }}"
                    inputId="{{ permission.id }}"
                    (onChange)="togglePermission(permission)"
                    [binary]="true"
                    [ngModel]="permission.isRequired"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <label class="check-options__label" [for]="permission.id">{{ permission.description | translate }}</label>
                </article>
              }
              <div class="divider"></div>
              <article class="check-options__item terms-container">                <p-checkbox
                  formControlName="termsAndConditions"
                  inputId="option-five"
                  [binary]="true"
                />
                <label class="check-options__label"
                  >{{ 'mcfLoginShell.signup.iAccept' | translate }}
                  <a href="#" (click)="openTerms($event)"
                    >{{ 'mcfLoginShell.signup.termsConditionsPrivacy' | translate }}</a
                  >
                </label>
              </article>
            </div>

            <div class="register-section__buttons-container">
              <button
                class="register-section__button"
                (click)="goBack()"
                type="button"
              >
                {{ "mcfLoginShell.signup.back" | translate }}
              </button>
              <p-button
                class="register-section__button--prime-button button--active"
                [disabled]="!myForm.get('termsAndConditions')?.value"
                (click)="submitForm()"
                type="submit"
                >{{ "mcfLoginShell.signup.send" | translate }}</p-button
              >


            </div>
          </form>
        </section>
    </main>
  }
</main>

<app-app-modal></app-app-modal>








